import { useState } from "react";
import styles from "./chatBotApiTest.module.css";

export const OrderPanel = ({ loading, onSubmit }) => {
  const [orderId, setOrderId] = useState("");
  const [hint, setHint] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!orderId.trim()) {
      setHint("Enter an order id or an invoice number.");
      return;
    }

    setHint("");
    onSubmit(orderId.trim());
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <label className={styles.field}>
        <span>Order ID or Invoice No</span>
        <input value={orderId} onChange={(event) => setOrderId(event.target.value)} placeholder="422306 or SI123456" />
      </label>

      <p className={styles.note}>
        Digits are read as an order id, anything else as an invoice number. The response says which one it used,
        and returns the order only when it belongs to your account or your company.
      </p>

      {hint ? <p className={styles.hint}>{hint}</p> : null}

      <button type="submit" className={styles.primaryButton} disabled={loading}>
        {loading ? "Sending…" : "Send request"}
      </button>
    </form>
  );
};
